// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ThreadHistory from 'conversations-message-history/thread-history/records/ThreadHistory';
import { getRecentHistory } from '../../../omnibus/public/operators';
export const buildThreadHistoryFromOmnibus = omnibus => {
  const history = getRecentHistory(omnibus);
  if (history) return new ThreadHistory(history);
  return null;
};